import { Fragment } from 'react';
import Link from 'next/link';
import { CheckIcon } from "@heroicons/react/outline";
import { Product } from '@/components/features/product/product.types';

interface AddToCartProps {
  isInCart: boolean;
  isUnverifiedUser: boolean;
  isAuthenticated: boolean;
  product: Product;
  quantity: number;
  onAddToCart: (product: Product, quantity: number) => void;
}

export const AddToCart = ({ 
  isInCart, 
  isUnverifiedUser, 
  isAuthenticated, 
  product, 
  quantity, 
  onAddToCart 
}: AddToCartProps) => (
  <div className="mt-10">
    {isInCart ? (
      <button disabled className="w-full bg-green-600 text-white py-3 px-8 rounded-md">
        In your cart <CheckIcon className="inline-block w-5 h-5 ml-2" />
      </button>
    ) : isUnverifiedUser ? (
      <Fragment>
        <button disabled className="w-full bg-indigo-600 text-white py-3 px-8 rounded-md">
          Cart disabled - Account not verified
        </button>
        <div className="mt-6 text-center">
          <Link href="/contact" className="text-indigo-600 hover:text-indigo-500">
            Contact us to get verified →
          </Link>
        </div>
      </Fragment>
    ) : isAuthenticated ? (
      <button
        onClick={() => onAddToCart(product, quantity)}
        className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-8 rounded-md"
      >
        Add to cart
      </button>
    ) : (
      <Link href="https://wavedistro.com/dealers" target="_blank">
        <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-8 rounded-md">
          Find a distributor
        </button>
      </Link>
    )}
  </div>
); 